import { RootState } from 'store/reducer';
import { createSelector } from 'reselect';

export const themeSelector = (state: RootState) => state.theme;

export const selectBrandTheme = createSelector([themeSelector], theme => theme.theme);

export const selectThemeFont = createSelector([themeSelector], theme => theme.theme?.font);
